// import Axios from 'axios'
import AuthAxios from '../../models/Axios'
import * as Types from '../../constants/actionTypes';
import { LOCAL_URL, API_REQUESTS, AUTH_SERVICE_URL } from '../../helper/constant'
import requestDetails from '../../models/requestDetail';
import { GET_USER_GROUP_BY_USERID } from './user'
import { getCollectionSiteID } from '../../helper/common';
import { error } from 'jquery';
// import Auth from '../../models/Auth';


export const REQUEST_TYPE = (portalId) => (dispatch) => {
    //console.log("programe Id", portalId, "Request id ", requestTypeId)
    dispatch({ type: Types.REQUEST_TYPE });

    // const filter = JSON.stringify({ "where": { "portalId": portalId }, "include": ["requestTypeInfo"] })

    AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.PROGRAM_REQUEST_TYPE}/listPortalRequestType`, { params: { portalId } })
        .then((response) => dispatch({
            type: Types.REQUEST_TYPE_SUCCESS,
            payload: response.data && response.data.data,
            //requestTytpe:payload
        })
        )
        .catch(error => dispatch({ type: Types.REQUEST_TYPE_ERROR, payload: error }))
}

export const CREATE_REQUEST = (payload) => async (dispatch) => {
    try {
        dispatch({ type: Types.GET_REQUEST });
        const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.REQUEST_DETAILS}/createRequestDetails`, payload)
        dispatch({
            type: Types.GET_REQUEST_ID,
            payload: response.data.data.id
        })

    } catch (error) {
        dispatch({ type: Types.GET_REQUEST_ID_ERROR, payload: error })
    }
}
export const ON_REQUEST_SUBMITTED = (payload) => async (dispatch) => {
    try {
        const { id, portalId, requestTypeId } = payload
        if (!id || !portalId || !requestTypeId) {
            return dispatch({ type: Types.REQUEST_STATUSES_ERROR, requestStatusesError: `Request is not found` })
        }
        const URL = `${LOCAL_URL}${API_REQUESTS.REQUEST_DETAILS}/initiateRequestStatus`
        await AuthAxios.axios.post(URL, payload)
    } catch (exception) {
        return dispatch({ type: Types.REQUEST_STATUSES_ERROR, payload: exception })
    }
}

export const SET_REQUEST_ID = (reqId) => (dispatch) => {
    dispatch({
        type: Types.GET_REQUEST_ID,
        payload: reqId
    })
}

// export const SEND_MAIL = (payload)=> async (dispatch)=>{
//     try{
//         const {toEmail,fromEmail, subject} = payload
//         if(!toEmail || !fromEmail || !subject){
//             return dispatch({type:Types.REQUEST_MAIL_ERROR, requestMailError :` Required Field is Missing`})
//         }
//         const EMAIL_URL = `${LOCAL_URL}${API_REQUESTS.EMAIL_SEND}`
//         const response = await AuthAxios.axios.post(EMAIL_URL, payload)
//         dispatch({
//             type: Types.MAIL_SEND_SUCCESS,
//             payload: response.data
//         })

//     }catch(exception){
//         return dispatch({type:Types.REQUEST_MAIL_ERROR, requestMailError:exception.message})
//     }
// }



export const SET_ASSET_LIST = (payload) => (dispatch) => {
    dispatch({
        type: Types.GET_ASSETS_UNDER_REQUEST_TYPE_SUCCESS,
        payload: payload
    })
}

export const SET_BULK_UPLOAD_ASSET_DATA = (payload) => (dispatch) => {
    dispatch({
        type: Types.SET_BULK_UPLOAD_ASSET_DATA_SUCCESS,
        payload: payload
    })
}

export const GET_ALL_ASSETS = (assetPayload) => async (dispatch) => {
    try {
        const response = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.PROGRAM_ASSETS}/getAssetPortalList`, { params: assetPayload })
        dispatch({
            type: Types.GET_PROGRAM_ASSETS_TYPE_SUCCESS,
            payload: response.data && response.data.data
        })
        return response.data && response.data.data;
    } catch (error) {
        dispatch({ type: Types.GET_ASSETS_TYPE_ERROR, payload: error })
    }
}


export const GET_ASSETS_TYPE = (assetPayload) => async (dispatch) => {
    try {
        dispatch({ type: Types.GET_ASSETS });
        // const filter = JSON.stringify({ "where": { "portalId": assetPayload.portalId, "requestTypeId": assetPayload.requestTypeId }, "include": "assetsInfo" })
        const response = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.PROGRAM_ASSETS}/getAssetPortalListWithDataBearing`, { params: assetPayload })
        dispatch({
            type: Types.GET_ASSETS_TYPE_SUCCESS,
            payload: response.data && response.data.data
        })
    } catch (error) {
        dispatch({ type: Types.GET_ASSETS_TYPE_ERROR, payload: error })
    }
}

export const GET_ASSETS_BY_QRCODE_DEFAULT_SERVICE = (payload) => async (dispatch) => {
    try {
        // const filter = JSON.stringify({ where: payload, include: [{ "relation": "assetsProgramInfo", "scope": { "fields": ["id", "assetName"] }}]});
        // const response = await AuthAxios.axios.get(`${LOCAL_URL}/StandardServices?filter=${filter}`);
        const { clientServiceGroupId, portalId, requestTypeId, countryId } = payload;
        const response = await AuthAxios.axios.get(`${LOCAL_URL}/StandardServices?filter[where][clientServiceGroupId]=${clientServiceGroupId}&filter[where][portalId]=${portalId}&filter[where][requestTypeId]=${requestTypeId}&filter[where][countryId]=${countryId}&filter[include][relation]=assetsProgramInfo&filter[include][scope][fields]=id&filter[include][scope][fields]=assetName`)
        dispatch({
            type: Types.GET_ASSETS_TYPE_SUCCESS,
            payload: response.data.filter(i => i.assetsProgramInfo).map(i => i.assetsProgramInfo).filter(
                (asset1, index, array) => index === array.findIndex(
                    asset2 => asset1.id === asset2.id
                        && asset1.assetName === asset2.assetName
                ))
        })
    } catch (error) {
        dispatch({ type: Types.GET_ASSETS_TYPE_ERROR, payload: error })
    }
}
export const GET_SERVICE_GROUPS = (payload) => async (dispatch) => {
    try {
        // const filter = JSON.stringify({ where: payload, include: [{ "relation": "clientServiceGroupInfo", "scope": { "fields": ["id", "clientServiceType"] }}]});
        // const response = await AuthAxios.axios.get(`${LOCAL_URL}/StandardServices?filter=${filter}`);
        const { portalId, requestTypeId, countryId } = payload;
        const response = await AuthAxios.axios.get(`${LOCAL_URL}/StandardServices?filter[where][portalId]=${portalId}&filter[where][requestTypeId]=${requestTypeId}&filter[where][countryId]=${countryId}&filter[include][relation]=clientServiceGroupInfo&filter[include][scope][fields]=id&filter[include][scope][fields]=clientServiceType`);

        dispatch({
            type: Types.GET_SERVICE_GROUPS_SUCCESS,
            payload: response.data.filter(i => i.clientServiceGroupInfo).map(i => i.clientServiceGroupInfo).filter(
                (item1, index, array) => index === array.findIndex(
                    item2 => item1.id === item2.id
                        && item1.clientServiceType === item2.clientServiceType
                ))
        })
    } catch (error) {
        dispatch({ type: Types.GET_SERVICE_GROUPS_ERROR, payload: error })
    }
}

export const GET_ADDITIONAL_INFO = (portalId) => async (dispatch) => {
    try {
        const response = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.PROGRAM_ADDITIONAL_INFO}/listPortalAdditionalInfo`, { params: portalId })
        dispatch({
            type: Types.GET_ADDITIONAL_INFO,
            payload: response.data && response.data.data
        })
    } catch (error) {
        dispatch({ type: Types.GET_ASSETS_TYPE_ERROR, payload: error })
    }
}


//Nitin's code
// GET : list of all the assets saved under one request to
//display in table

export const GET_ASSETS_UNDER_REQUEST = (assetPayload) => async (dispatch) => {
    // dispatch({type: Types.GET_ASSETS_UNDER_REQUEST});
    // const filter = JSON.stringify({ "where": { "requestId": assetPayload.requestId }, "include": "assetsInfo" })

    try {
        const response = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.NEW_REQUEST_ASSET}/fetchNewRequestAssets`, { params: { requestId: assetPayload.requestId } })
        dispatch({
            type: Types.GET_ASSETS_UNDER_REQUEST_TYPE_SUCCESS,
            payload: response.data && response.data.data
        })
    } catch (error) {
        dispatch({ type: Types.GET_ASSETS_UNDER_REQUEST_TYPE_ERROR, payload: error })
    }

}
export const SET_ASSETS_UNDER_REQUEST_EMPTY = (assetPayload) => async (dispatch) => {
    dispatch({
        type: Types.GET_ASSETS_UNDER_REQUEST_TYPE_SUCCESS,
        payload: assetPayload
    })
}
export const SET_ASSETSEXCEL_UNDER_REQUEST_EMPTY = (assetPayload) => async (dispatch) => {
    dispatch({
        type: Types.GET_ASSETSEXCEL_UNDER_REQUEST_TYPE_SUCCESS,
        payload: assetPayload
    })
}

export const GET_ASSETSEXCEL_UNDER_REQUEST = (assetPayload) => async (dispatch) => {
    // dispatch({type: Types.GET_ASSETS_UNDER_REQUEST});
    // const filter = JSON.stringify({ "where": { "requestId": assetPayload.requestId }, "include": "assetsInfo" })

    AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.ASSET_EXCEL_REQ}/fetchRequestAssets`, { params: { requestId: assetPayload.requestId, filters: assetPayload.filters } })
        .then((response) => {
            dispatch({
                type: Types.GET_ASSETSEXCEL_UNDER_REQUEST_TYPE_SUCCESS,
                payload: response.data && response.data.data,
            })
            //this.setState()
            //toast.info("Language Added Successfully");
        }
        )
        .catch(error => dispatch({ type: Types.GET_ASSETSEXCEL_UNDER_REQUEST_TYPE_ERROR, payload: error }))
}
export const GET_ASSETSEXCEL_UNDER_REQUEST_ON_DIALOG = (assetPayload) => async (dispatch) => {
    // dispatch({type: Types.GET_ASSETS_UNDER_REQUEST});
    // const filter = JSON.stringify({ "where": { "requestId": assetPayload.requestId }, "include": "assetsInfo" })

    AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.ASSET_EXCEL_REQ}/fetchRequestAssetsOnDialog`, { requestId: assetPayload.requestId, filters: assetPayload.filters })
        .then((response) => {
            dispatch({
                type: Types.GET_ASSETSEXCEL_UNDER_REQUEST_TYPE_SUCCESS_ON_DIALOG,
                payload: response.data && response.data.data,
            })
            //this.setState()
            //toast.info("Language Added Successfully");
        }
        )
        .catch(error => dispatch({ type: Types.GET_ASSETSEXCEL_UNDER_REQUEST_TYPE_ERROR, payload: error }))
}

export const GET_RECYLCLEPARTNER_LIST_TYPE = (payload) => async (dispatch) => {
    //  console.log('payload', payload)
    const { clientId, portalId } = payload
    if (!clientId || !portalId) {
        // console.log(`Error Condition`);
    }
    dispatch({ type: Types.GET_RECYLCLEPARTNER_LIST });

    try {
        const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.PROGRAM_RECYLCLEPARTNER_LIST}/fetchPortalProcessingPartner`, payload);
        dispatch({
            type: Types.GET_RECYLCLEPARTNER_LIST_TYPE_SUCCESS,
            payload: response.data && response.data.data
        })
    } catch (error) {
        dispatch({ type: Types.GET_RECYLCLEPARTNER_LIST_TYPE_ERROR, payload: error })
    }
}

//Nitin's code end here
export const GET_ASSET_EXCEL_SAVE = (payload) => async (dispatch) => {
    try {
        dispatch({ type: Types.ASSETS_DETAIL_SAVE });
        const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.SAVE_ASSET_EXCEL}`, payload);
        dispatch({
            type: Types.ASSETS_DETAIL_SAVE_SUCCESS,
            payload: response.data
        })
    } catch (error) {
        dispatch({ type: Types.ASSETS_DETAIL_SAVE_ERROR, payload: error })
    }
}
export const UPDATE_ASSET_EXCEL = (payload) => async (dispatch) => {
    try {
        dispatch({ type: Types.ASSETS_DETAIL_SAVE });
        const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.UPDATE_EXCEL_SERVICE}`, payload);
        dispatch({
            type: Types.ASSETS_DETAIL_SAVE_SUCCESS,
            payload: response.data
        })
    } catch (error) {
        dispatch({ type: Types.ASSETS_DETAIL_SAVE_ERROR, payload: error })
    }
}

export const GET_ASSETS_SAVE = (payload) => async (dispatch) => {

    try {
        dispatch({ type: Types.ASSETS_DETAIL_SAVE });
        const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.SAVE_ASSETS}`, payload);
        dispatch({
            type: Types.ASSETS_DETAIL_SAVE_SUCCESS,
            payload: response.data
        })
    } catch (error) {
        dispatch({ type: Types.ASSETS_DETAIL_SAVE_ERROR, payload: error })
    }
}
//for updating asset quantity
export const UPDATE_ASSET = (payload) => async (dispatch) => {
    try {
        const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.UPDATE_ASSET}`, payload);
        dispatch({
            type: Types.UPDATE_ASSET_SUCCESS,
            payload: response.data
        })
    } catch (error) {
        dispatch({ type: Types.ASSETS_DETAIL_SAVE_ERROR, payload: error })
    }
}

//for saving services in new request asset table
export const SAVE_SERVICE = (payload) => (dispatch) => {
    AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.SAVE_SERVICE}`, payload)
        .then(response => {
            dispatch({
                type: Types.SAVE_SERVICE_SUCCESS,
                payload: response.data
            })
        })
        .catch(error => dispatch({
            type: Types.SAVE_SERVICE_ERROR,
            error: error.response
        })
        )

}
export const SAVE_EXCEL_SERVICE = (payload) => (dispatch) => {
    AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.SAVE_EXCEL_SERVICE}`, payload)
        .then(response => {
            dispatch({
                type: Types.SAVE_SERVICE_SUCCESS,
                payload: response.data
            })
        })
        .catch(error => dispatch({
            type: Types.SAVE_SERVICE_ERROR,
            error: error.response
        })
        )

}
export const SAVE_REQUEST_SERVICE = (payload) => (dispatch) => {
    const { id } = payload
    // console.log("Service Payload", payload)
    if (!id) {
        AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.REQUEST_SERVICE}/saveservice`, payload)
            .then(response => {
                dispatch({
                    type: Types.SAVE_REQUEST_SERVICE,
                    payload: response.data
                })
            })
            .catch(error => dispatch({
                type: Types.SAVE_REQUEST_SERVICE_ERROR,
                error: error.response
            })
            )
    } else {
        AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.REQUEST_SERVICE}/updateservice`, payload)
            .then(response => {
                dispatch({
                    type: Types.SAVE_REQUEST_SERVICE,
                    payload: response.data
                })
            })
            .catch(error => dispatch({
                type: Types.SAVE_REQUEST_SERVICE_ERROR,
                error: error.response
            })
            )
    }



}

export const GET_ADDED_SERVICE = (payload) => async (dispatch) => {
    try {
        const { requestId } = payload
        if (!requestId) {
            // console.log(`request Id is not found`);
            return;
        }
        const response = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.REQUEST_SERVICE}/getservice`, { params: payload })
        // console.log(`get service response is:`,response);
        dispatch({
            type: Types.GET_REQUEST_SERVICE,
            payload: response.data.data
        })
    } catch (error) {

        dispatch({
            type: Types.GET_REQUEST_SERVICE_ERROR,
            error: error.response
        })
    }
}
export const GET_ASSETS_SAVE_LIST = (payload) => (dispatch) => {
    AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.REQUEST_ASSETS}`)
        .then((response) => {
            dispatch({
                type: Types.ASSETS_DETAIL_SAVE_LIST,
                payload: response.data
            })
            //toast.info("Language Added Successfully");
        })
    //.catch(error => dispatch({type: Types.ASSETS_DETAIL_SAVE_ERROR, payload:error}))
}


export const UPDATE_REQUEST_SERVICES = (payload) => (dispatch) => {
    dispatch({ type: Types.UPDATED_REQUEST });
    AuthAxios.axios.patch(`${LOCAL_URL}${API_REQUESTS.REQUEST_DETAILS}/${payload.requestId}`,
        payload
    )
        .then((response) => {
            dispatch({
                type: Types.REQUEST_LIST_DETAILS_SUCCESS,
                payload: response.data
            })
            //toast.info("Packing Added Successfully");
        })
        .catch(error => dispatch({ type: Types.UPDATED_REQUEST_ERROR, payload: error }))
}


export const UPDATE_REQUEST_DETAIL = (payload) => async (dispatch) => {
    try {
        const { id } = payload;
        if (!id) {
            // console.log(`request is not found`);
            dispatch({ type: Types.REQUEST_STATUSES_ERROR, requestStatusesError: `Request is not found` })
            return;
        }
        const updatedResponse = await requestDetails.updateProcessRequestDetails(payload);
        if (updatedResponse) {
            dispatch({ type: Types.REQUEST_LIST_DETAILS_SUCCESS, payload: updatedResponse });
        }
    } catch (exception) {
        dispatch({ type: Types.REQUEST_STATUSES_ERROR, payload: JSON.parse(exception).message })
    }
}

export const ON_REJECT_REQUEST = (payload) => async (dispatch) => {
    try {
        const { requestId, statusId } = payload;
        if (!requestId || !statusId) {
            return;
        }
        await requestDetails.rejectRequestStatus(payload);
        dispatch({ type: Types.SET_REQUEST_REJECTED, isRequestRejected: true })
    } catch (exception) {
        dispatch({ type: Types.REQUEST_STATUSES_ERROR, requestStatusesError: exception.message })
    }
}

export const GET_QUOTE_DETAIL = (payload) => async (dispatch) => {
    try {
        const { requestId } = payload
        if (!requestId) {
            return dispatch({ type: Types.GET_SERVICES_ERROR, payload: `Please provide request information ` })
        }
        const URL = `${LOCAL_URL}${API_REQUESTS.REQUEST_QUOTE}/getquoteinfo`
        const response = await AuthAxios.axios.get(URL, { params: payload })
        dispatch({
            type: Types.REQUEST_QUOTE_INFO,
            payload: response.data && response.data.data,
            //requestTytpe:payload
        })
    } catch (error) {
        dispatch({ type: Types.GET_SERVICES_ERROR, payload: error && error.message })
    }
}
export const CLEAR_QUOTE_DETAIL = () => (dispatch) => {
    dispatch({
        type: Types.REQUEST_QUOTE_INFO,
        payload: {}
    })
}

export const CLEAR_ASSETS_DETAIL_SAVE_ERROR = () => (dispatch) => {
    dispatch({
        type: Types.ASSETS_DETAIL_SAVE_ERROR,
        payload: null
    })
}

export const UPDATE_QUOTE_DETAIL = (payload) => async (dispatch) => {
    try {
        const { requestId } = payload
        if (!requestId) {
            return dispatch({ type: Types.GET_SERVICES_ERROR, payload: `Please provide request information ` })
        }
        const URL = `${LOCAL_URL}${API_REQUESTS.REQUEST_QUOTE}/updatequoteinfo`
        const response = await AuthAxios.axios.post(URL, payload)
        dispatch({
            type: Types.REQUEST_QUOTE_INFO,
            payload: response.data.data,
            //requestTytpe:payload
        })
    } catch (error) {
        dispatch({ type: Types.GET_SERVICES_ERROR, payload: error && error.message })
    }
}

export const UPDATE_QUOTE_MESSAGE = (payload) => async (dispatch) => {
    try {
        const { requestId } = payload
        if (!requestId) {
            return dispatch({ type: Types.GET_SERVICES_ERROR, payload: `Please provide request information ` })
        }
        const URL = `${LOCAL_URL}${API_REQUESTS.REQUEST_QUOTE}/updatequotemessage`
        await AuthAxios.axios.post(URL, payload)
    } catch (error) {
        dispatch({ type: Types.GET_SERVICES_ERROR, payload: error && error.message })
    }
}

export const SET_REQUEST_DETAIL_DATA = (payload) => (dispatch) => {
    dispatch({ type: Types.REQUEST_LIST_DETAILS_SUCCESS, payload });
}

export const GET_SERVICES = (clientId) => (dispatch) => {
    AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.TES_SERVICES_TYPE}`)
        .then((response) => dispatch({
            type: Types.GET_SERVICES_SUCCESS,
            payload: response.data,
            //requestTytpe:payload
        })
        )
        .catch(error => dispatch({ type: Types.GET_SERVICES_ERROR, payload: error }))
}

export const GET_CLIENT_SERVICE_TYPE = (payload) => async (dispatch) => {
    const SERVICE_URL = `${LOCAL_URL}${API_REQUESTS.CLIENT_SERVICE_TYPE_URL}/getClientServiceType`
    try {
        const response = await AuthAxios.axios.post(SERVICE_URL, payload)
        dispatch({
            type: Types.GET_CLIENT_SERVICE_TYPE,
            payload: response.data
        })
    }
    catch (error) {
        dispatch({ type: Types.GET_SERVICES_ERROR, payload: error })
    }

}

export const SELECTED_SERVICES = (payload) => (dispatch) => {
    // deprecated
    // const filter = JSON.stringify({ "where": { serviceTypeId: payload }, "include": "serviceInfo" })
    AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.TES_SERVICES}/getServicesByServiceType`, { serviceTypeId: payload })
        .then((response) => dispatch({
            type: Types.SELECTED_SERVICES_SUCCESS,
            payload: response.data,
            //requestTytpe:payload
        })
        )
        .catch(error => dispatch({ type: Types.GET_SERVICES_ERROR, payload: error }))
}

export const SET_SELECTED_SERVICETYPE = (serviceTypeData) => (dispatch) => {
    dispatch({ type: Types.SELECTED_SERVICES_SUCCESS, payload: serviceTypeData })
}

export const GET_CLIENT_SERVICES = (payload) => async (dispatch) => {
    try {
        const { clientId } = payload
        if (!clientId) {
            dispatch({ type: Types.CLIENT_SERVICES_ERROR, message: `Please provide client Information properly` })
            return;
        }
        const response = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.GET_CLIENT_SERVICES}/getClientServices`, { params: payload })
        dispatch({
            type: Types.CLIENT_SERVICES_SUCCESS,
            payload: response.data && response.data.data,
            //requestTytpe:payload
        })
    } catch (error) {
        dispatch({ type: Types.CLIENT_SERVICES_ERROR, payload: error })
    }
}

export const GET_EXTRA_SERVICES = (payload) => async (dispatch) => {
    try {
        const { clientId } = payload
        if (!clientId) {
            dispatch({ type: Types.CLIENT_SERVICES_ERROR, payload: `Please provide Service Information properly.` })
            return;
        }
        // const whereFilter = { clientId, serviceTypeId }
        // let filter = { where: whereFilter, "include": ["serviceInfo", "serviceTypeInfo"] }
        // const finalFilter = JSON.stringify(filter)
        const response = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.GET_CLIENT_SERVICES}/getClientServices`, { params: payload })
        dispatch({
            type: Types.EXTRA_SERVICES_INFORMATION,
            extraServices: response.data && response.data.data,
            //requestTytpe:payload
        })
    } catch (error) {
        dispatch({ type: Types.CLIENT_SERVICES_ERROR, payload: error })
    }
}


export const UPLOAD_ASSETS_LIST = (fileData, payload) => async (dispatch) => {
    try {
        // console.log('payload', payload);
        const { portalId, clientId } = payload;
        if (!portalId || !clientId) {
            dispatch({ type: Types.UPLOAD_ASSET_LIST_ERROR, payload: `Please provide Program Information` })
        }

        const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.UPLOAD_ASSET}`, fileData, { params: payload });
        dispatch({
            type: Types.UPLOAD_ASSET_LIST_SUCCESS,
            payload: response.status
        })
    } catch (error) {
        dispatch({ type: Types.UPLOAD_ASSET_LIST_ERROR, payload: error })
    }
}
export const SET_BULK_UPLOAD_DATA = (payload) => async (dispatch) => {
    try {
        dispatch({
            type: Types.BULK_ASSET_UPLOAD_SUCCESS,
            payload: payload
        })
    } catch (error) {
        dispatch({ type: Types.UPLOAD_ASSET_LIST_ERROR, payload: error })
    }
}


export const GET_ADDRESS_COLLECTION = (payload) => async (dispatch) => {
    try {
        const { portalId, clientId, adminPortalList, countries, siteIds } = payload
        if (!portalId) {
            return
        }
        let addressCollections = await requestDetails.getAddressCollections({ portalId, adminPortalList, countries, siteIds })
        if (addressCollections && addressCollections.data) {
            let finalData = addressCollections && addressCollections.data.sort((a, b) => (a.siteId.toLowerCase() > b.siteId.toLowerCase()) ? 1 : -1);
            dispatch({ type: Types.SET_ADDRESS_COLLECTIONS, data: finalData })
            return finalData
        }
    } catch (exception) {
        //console.log(`error on get address collection`, exception);
    }
}

export const SET_ADDRESS_COLLECTIONS = (data = []) => (dispatch) => {
    dispatch({ type: Types.SET_ADDRESS_COLLECTIONS, data })
}

export const DELETE_ADDRESS_COLLECTION = (payload, callback) => async (dispatch) => {
    try {
        await requestDetails.deleteAddressCollection(payload)
        dispatch({
            type: Types.DELETE_ADDRESS_COLLECTION_SUCCESS,
            payload
        })
    } catch (error) {
        dispatch({ type: Types.PORTAL_COLLECTION_ADDRESS_ERROR, payload: error })
    }
}

export const ADD_ADDRESS_COLLECTION = (payload) => async (dispatch) => {
    try {
        const response = await requestDetails.addAddressCollection(payload);
        dispatch({
            type: Types.ADD_ADDRESS_COLLECTION_DETAILS_SUCCESS,
            payload: response.data
        })

    } catch (exception) {
        dispatch({ type: Types.ADD_ADDRESS_COLLECTION_ERROR, payload: exception.message })
    }
}
export const SET_ADDRESS_COLLECTION_EMPTY = (payload) => async (dispatch) => {
    dispatch({ type: Types.ADD_ADDRESS_COLLECTION_ERROR, payload: payload })
}

export const UPDATE_COLLECTION_ADDRESS = (payload) => async (dispatch) => {
    try {
        payload.siteId = getCollectionSiteID(payload.portalId, payload.siteId)
        await requestDetails.updateAddressCollection(payload);
        dispatch({ type: Types.UPDATED_COLLECTION_ADDRESS, updatedCollection: payload })
    } catch (error) {
        dispatch({ type: Types.PORTAL_COLLECTION_ADDRESS_ERROR, addressError: error && error.message })
    }
}

export const GET_ADDRESS_COLLECTION_BY_SITE_ID = (params) => async (dispatch) => {
    try {
        if (!params.clientId || !params.portalId || !params.siteId) {
            return
        }
        params.siteId = getCollectionSiteID(params.portalId, params.siteId)
        const addressCollectionsDetails = await requestDetails.getAddressCollectionBySiteId(params);
        dispatch({
            type: Types.ADDRESS_COLLECTION_BY_SITE_ID_SUCCESS,
            payload: addressCollectionsDetails.data
        })
    } catch (exception) {
        dispatch({ type: Types.ADDRESS_COLLECTION_BY_SITE_ID_ERROR, payload: exception })
    }
}

export const GET_DESTINATION_ADDRESS = (params) => async (dispatch) => {
    try {
        if (!params.clientId || !params.portalId || !params.siteId) {
            return
        }
        params.siteId = getCollectionSiteID(params.portalId, params.siteId)
        const destinationAddress = await requestDetails.getAddressCollectionBySiteId(params);
        dispatch({
            type: Types.DESTINATION_ADDRESS_SUCCESS,
            payload: destinationAddress.data
        })
    } catch (exception) {
        dispatch({ type: Types.ADDRESS_COLLECTION_BY_SITE_ID_ERROR, payload: exception })
    }
}

export const GET_ADDRESS_LIST = (payload) => async (dispatch) => {
    try {
        const addressList = await requestDetails.getrequestAddress(payload)
        dispatch({ type: Types.GET_ADDRESS_LIST, addressList })
    } catch (exception) {
        //console.log(`error on get address collection`, exception);
    }
}
export const PROGRAM_COUNTRIES = (portalId) => async (dispatch) => {
    try {
        // const filter = JSON.stringify({ "where": { "portalId": portalId }, "include": [{ "relation": "countryInfo", "scope": { "fields": ["name"] } }] })
        const COUNTRY_URL = `${LOCAL_URL}${API_REQUESTS.PROGRAM_COUNTRY_URL}/getPortalCountryList`
        const response = await AuthAxios.axios.get(COUNTRY_URL, { params: { portalId: portalId } })
        const countries = response.data && response.data.data
        dispatch({ type: Types.COUNTRIES_DETAIL_SUCCESS, payload: countries })
        return countries
    } catch (error) {
        dispatch({ type: Types.REQUEST_ERROR, error })
    }
}


export const LIST_PROGRAM_COMPANIES = (payload) => async (dispatch) => {
    try {
        const PROGRAM_COMPANY_URL = `${AUTH_SERVICE_URL}${API_REQUESTS.PROGRAM_COMPANY_URL}/listPortalCompanies`
        const response = await AuthAxios.axios.get(PROGRAM_COMPANY_URL, { params: payload });
        dispatch({
            // type: Types.PROGRAM_COMPANY_LIST,
            type: Types.FETCH_PORTAL_USER_COMPANIES,
            payload: response?.data?.data,
        })
        return response.data && response?.data?.data
    } catch (exception) {
        dispatch({ type: Types.REQUEST_ERROR, exception })
    }
}

export const DELETE_PROGRAM_COMPANY = (payload, deletedIndex) => async (dispatch) => {
    try {
        const { id } = payload;
        if (!id) {
            dispatch({ type: Types.REQUEST_ERROR, error: `Program Company not found for Deletion` })
            return;
        }
        const PROGRAM_COMPANY_URL = `${LOCAL_URL}${API_REQUESTS.PROGRAM_COMPANY_URL}/deleteCompany`
        await AuthAxios.axios.post(PROGRAM_COMPANY_URL, payload)
        dispatch({ type: Types.DELETE_PROGRAM_COMPANY, deletedIndex })
    } catch (exception) {
        dispatch({ type: Types.REQUEST_ERROR, payload: exception })
    }
}

export const ADD_PROGRAM_COMPANY = (payload) => async (dispatch) => {
    try {
        if (!payload.portalId || !payload.name) {
            dispatch({ type: Types.REQUEST_ERROR, programCompanyError: `Add Program Company does not have all required fields` })
        }
        const PROGRAM_COMPANY_URL = `${LOCAL_URL}${API_REQUESTS.PROGRAM_COMPANY_URL}/createNew`
        const response = await AuthAxios.axios.post(PROGRAM_COMPANY_URL, payload)
        dispatch({ type: Types.ADD_PROGRAM_COMPANY, addProgramCompany: response.data.data })
    } catch (exception) {
        dispatch({ type: Types.REQUEST_ERROR, exception })
    }
}

export const getPortaUserCompanies = ({ portalId, userId }) => (dispatch) => {
    AuthAxios.axios.post(`${AUTH_SERVICE_URL}/portalusercompanies/getList`, { portalId, userId })
    .then(response => {
        dispatch({
            type: Types.FETCH_PORTAL_USER_COMPANIES,
            payload: response.data,
        });
    });
}

export const ADD_PORTAL_USER_COMPANIES = ({ portalId, userId, name, countryId }) => async (dispatch) => {
    try {
        const response = await AuthAxios.axios.post(`${LOCAL_URL}/portalUserCompanies/addByName`, { portalId, userId, name, countryId })
        dispatch({
            type: Types.ADD_PORTAL_USER_COMPANIES,
            payload: response.data,
        });
    } catch (error) {
        dispatch({ type: Types.ADD_NEW_COMPANY_ERROR, payload: error.error })
    }
}

export const setAddNewCompanyResponse = (response) => (dispatch) => { dispatch({ type: Types.SET_ADD_NEW_COMPANY_RESPONSE, response }) }

export const ADD_NEW_ADDRESS = (payload) => async (dispatch) => {
    const { siteId } = payload
    if (!siteId) {
        dispatch({ type: Types.REQUEST_ERROR, error: "Site Id not Define" })
        return
    }
    try {
        const addressAdded = await requestDetails.addNewAddress(payload)
        if (addressAdded) {
            dispatch({ type: Types.NEW_ADDRESS_ADDED, addressAdded })
        }
    } catch (error) {
        dispatch({ type: Types.REQUEST_ERROR, error })
    }
}

export const DELETE_SELECTED_ASSET = (id) => async (dispatch) => {
    try {
        if (!id) {
            return dispatch({ type: Types.DELETE_SELECTED_ERROR, payload: `Please provide asset Information for deletion` })
        }
        dispatch({ type: Types.DELETE_SELECTED_ASSET });
        const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.DELETE_ASSETS}`, { "id": id })
        dispatch({
            type: Types.DELETE_SELECTED_SUCCESS,
            payload: response.data.id,
        })
    } catch (error) {
        dispatch({ type: Types.DELETE_SELECTED_ERROR, payload: error })
    }
}

export const DELETE_SELECTED_ASSETEXCEL = (id) => async (dispatch) => {
    try {
        if (!id) {
            return dispatch({ type: Types.DELETE_SELECTED_ERROR, payload: `Please provide asset Information for deletion` })
        }
        dispatch({ type: Types.DELETE_SELECTED_ASSET });
        const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.DELETE_ASSET_EXCEL}`, { "id": id })
        dispatch({
            type: Types.DELETE_SELECTED_SUCCESS,
            payload: response.data.id,
        })
    } catch (error) {
        dispatch({ type: Types.DELETE_SELECTED_ERROR, payload: error })
    }
}

export const SAVED_SERVICES_UNDER_ASSET = (requestId) => async (dispatch) => {

    try {
        if (!requestId) {
            return;
        }

        const response = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.NEW_REQUEST_ASSET}/fetchNewRequestAssets`, { params: { requestId: requestId } })
        dispatch({
            type: Types.SAVED_SERVICES_UNDER_ASSET_SUCCESS,
            payload: response.data.data
        })
    } catch (error) {
        dispatch({ type: Types.SAVED_SERVICES_UNDER_ASSET_ERROR, payload: error })
    }

}

export const SAVED_SERVICES_UNDER_EXCEL_ASSET = (requestId) => async (dispatch) => {

    try {
        if (!requestId) {
            return;
        }

        const response = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.ASSET_EXCEL_REQ}/fetchRequestAssets`, { params: { requestId: requestId } })
        dispatch({
            type: Types.SAVED_SERVICES_UNDER_EXCEL_ASSET_SUCCESS,
            payload: response.data.data
        })
    } catch (error) {
        dispatch({ type: Types.SAVED_SERVICES_UNDER_EXCEL_ASSET_ERROR, payload: error })
    }

}

export const GET_PACKING = (portalId) => async (dispatch) => {
    try {
        const response = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.PACKING_PORTAL_URL}/listPackingPortal`, { params: { portalId: portalId } })

        dispatch({
            type: Types.GET_PACKING_PORTAL_LIST,
            payload: response.data && response.data.data
        })
    } catch (exception) {
        dispatch({
            type: Types.BOX_OR_PACK_ERROR,
            payload: exception,
        })
    }
}
export const ADD_REQUEST_PACKING = (payload) => async (dispatch) => {
    try {
        const addedPackingInfo = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.REQUEST_PACKING}/addPackings`, payload)
        if (addedPackingInfo && addedPackingInfo.data) {
            dispatch({
                type: Types.ADD_REQUEST_PACKING_SUCCESS,
                payload: addedPackingInfo.data.data
            })
        }
    } catch (error) {
        dispatch({
            type: Types.BOX_OR_PACK_ERROR,
            payload: error,
        })
    }
}
export const GET_REQUEST_PACKING = (payload) => async (dispatch) => {
    try {
        if (!payload) {
            return
        }
        const requestPackingData = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.REQUEST_PACKING}/getPacking`, { params: payload })
        let payloadData = []
        if (requestPackingData && requestPackingData.data) {
            payloadData = requestPackingData.data.data
        }
        dispatch({
            type: Types.GET_REQUEST_PACKING,
            payload: payloadData
        })
    } catch (error) {
        dispatch({
            type: Types.BOX_OR_PACK_ERROR,
            payload: error,
        })
    }


}
export const DELETE_REQUEST_PACKING = (payload, delIndex) => async (dispatch) => {
    try {
        const { id } = payload
        if (!id) {
            dispatch({
                type: Types.BOX_OR_PACK_ERROR,
                payload: `Please Provide Box Information*`
            })
            return
        }
        await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.REQUEST_PACKING}/deletePackings`, payload)
        dispatch({
            type: Types.DELETE_REQUEST_PACKING,
            delIndex
        })
    } catch (exception) {
        dispatch({
            type: Types.BOX_OR_PACK_ERROR,
            payload: exception
        })
    }
}
export const SET_BOX_PACK_ERROR = (message) => (dispatch) => {
    dispatch({
        type: Types.BOX_OR_PACK_ERROR,
        payload: message
    })
}

export const GET_BOXES = (portalId) => async (dispatch) => {
    try {
        if (!portalId) {
            return dispatch({
                type: Types.BOX_OR_PACK_ERROR,
                payload: `Please provide Portal Information`
            })
        }
        // const filter = JSON.stringify({ "where": { "portalId": portalId }, "include": { relation: 'boxInfo' } })
        const boxesList = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.BOXES_LIST}/listPortalBoxesList`, { params: { portalId: portalId } })
        dispatch({
            type: Types.GET_BOXES_LIST,
            payload: boxesList.data && boxesList.data.data,
        })
    } catch (exception) {
        dispatch({
            type: Types.BOX_OR_PACK_ERROR,
            payload: exception
        })
    }
}

export const GET_PACKAGING_DETAILS = (payload) => async (dispatch) => {
    try {
        const PACKAGING_INFO_URL = `${LOCAL_URL}${API_REQUESTS.PACKAGING_URL}/getPortalPackingList`
        const response = await AuthAxios.axios.get(PACKAGING_INFO_URL, { params: payload })
        dispatch({
            type: Types.PACKAGING_DETAIL_SUCCESS,
            payload: response.data.data
        })
    } catch (error) {
        let message = error.message
        if (!message && error.error) {
            message = error.error.message
        }
        dispatch({ type: Types.PACKAGING_ERROR, packingError: message })
    }
}

export const ADD_PACKAGING_DIMENSIONS = (payload) => async (dispatch) => {
    try {
        const PACKAGING_INFO_URL = `${LOCAL_URL}${API_REQUESTS.DIMENSIONS_URL}/addDimensions`
        const response = await AuthAxios.axios.post(PACKAGING_INFO_URL, payload)
        //console.log(`addPackaginData is:`,addPackData);
        return response.data && response.data.data

    } catch (error) {
        let message = error.message
        if (!message && error.error) {
            message = error.error.message
        }
        dispatch({ type: Types.DIMENSIONS_ERROR, dimensionsError: message })
    }

}

export const GET_DIMENSIONS_LIST = () => async (dispatch) => {
    try {
        const URL = `${LOCAL_URL}${API_REQUESTS.DIMENSIONS_URL}/getDimensionsList`
        const response = await AuthAxios.axios.get(URL);
        dispatch({ type: Types.DIMENSIONS_LIST, dimensionsList: response.data && response.data.data })
    } catch (err) {
        dispatch({ type: Types.DIMENSIONS_ERROR, dimensionsError: err.message })
    }
}

export const DIMENSIONS_ERROR = (message) => (dispatch) => {
    dispatch({
        type: Types.DIMENSIONS_ERROR,
        payload: message
    })
}
/****************************** Labels Implement ******************************* */
export const SET_LABEL_ERROR = (message) => (dispatch) => {
    dispatch({
        type: Types.LABEL_ERROR,
        payload: message
    })
}

export const GET_LABELS = (portalId) => async (dispatch) => {
    try {
        if (!portalId) {
            return dispatch({
                type: Types.LABEL_ERROR,
                payload: `Please provide Portal Information`
            })
        }
        const labelsList = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.LABELS_LIST}/getProgramLabel`, { portalId })

        dispatch({
            type: Types.GET_LABEL_LIST,
            payload: labelsList.data && labelsList.data.data,
        })
    } catch (exception) {
        dispatch({
            type: Types.LABEL_ERROR,
            payload: exception
        })
    }
}


export const ADD_REQUEST_LABEL = (payload) => async (dispatch) => {
    try {
        const addedLabelInfo = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.REQUEST_LABEL}/addLabels`, payload)
        if (addedLabelInfo && addedLabelInfo.data) {
            dispatch({
                type: Types.ADD_REQUEST_LABEL_SUCCESS,
                payload: addedLabelInfo.data.data
            })
        }
    } catch (error) {
        dispatch({
            type: Types.LABEL_ERROR,
            payload: error,
        })
    }
}
export const GET_REQUEST_LABEL = (payload) => async (dispatch) => {
    try {
        if (!payload) {
            return
        }
        const requestLabelData = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.REQUEST_LABEL}/getRequestLabels`, { params: payload })
        let payloadData = []
        if (requestLabelData && requestLabelData.data) {
            payloadData = requestLabelData.data.data
        }
        dispatch({
            type: Types.GET_REQUEST_LABEL,
            payload: payloadData
        })
    } catch (error) {
        dispatch({
            type: Types.LABEL_ERROR,
            payload: error,
        })
    }


}
export const DELETE_REQUEST_LABEL = (payload, delIndex) => async (dispatch) => {
    try {
        const { id } = payload
        if (!id) {
            dispatch({
                type: Types.LABEL_ERROR,
                payload: `Please Provide Label Information*`
            })
            return
        }
        await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.REQUEST_LABEL}/deleteLabels`, payload)
        dispatch({
            type: Types.DELETE_REQUEST_LABEL,
            delIndex
        })
    } catch (exception) {
        dispatch({
            type: Types.LABEL_ERROR,
            payload: exception
        })
    }
}

/* List request Stages Information */
export const LIST_REQUEST_STAGE_DETAILS = (payload) => async (dispatch) => {
    try {
        const { portalId, requestTypeId } = payload
        if (!portalId || !requestTypeId) {
            return
        }
        const requestStageDetails = await requestDetails.listProgramRequestStages(payload);
        dispatch({ type: Types.PROGRAM_REQUEST_STAGES, programRequestStages: requestStageDetails })
        // console.log(`request stage details are:`, requestStageDetails)
    } catch (exception) {
        dispatch({ type: Types.PROGRAM_STAGE_ERROR, programStageError: exception.message })
    }
}

export const PORTAL_STAGE_STATUS_INFO = (payload) => async (dispatch) => {
    try {
        const { portalId, requestTypeId, clientId } = payload
        // console.log(`portal stage status Info >>>>>>>>>. `, payload)
        if (!portalId || !requestTypeId || !clientId) {
            return dispatch({ type: Types.REQUEST_STATUSES_ERROR, requestStatusesError: `Please Provide Stage Status Information` })
        }
        const portalStageStatusList = await requestDetails.listPortalStageStatuses(payload);
        dispatch({ type: Types.PROGRAM_STAGE_STATUS_LIST, portalStageStatusList })
    } catch (error) {
        return dispatch({ type: Types.REQUEST_STATUSES_ERROR, requestStatusesError: error.message })
    }
}


/* Fetch Request Type Input Fields */
export const FETCH_PORTAL_REQUEST_TYPE_INPUTFIELDS = (payload) => async (dispatch) => {
    try {
        const { portalId, requestTypeId } = payload;
        if (!portalId || !requestTypeId) {
            dispatch({ type: Types.PROGRAM_STAGE_ERROR, programStageError: `Please provide Portal Stage Input Fields Information` })
            return;
        }
        const requestTypeInputFields = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.PROGRAM_REQUEST_STAGE_INPUTFILEDS}/fetchPortalRequestTypeFields`, payload);
        //console.log(`portalRequestType Input fields `, requestTypeInputFields)
        dispatch({
            type: Types.REQUEST_TYPE_INPUT_FIELDS,
            portalRequestInputFields: requestTypeInputFields.data ? requestTypeInputFields.data.data : null
        });
    } catch (error) {
        dispatch({ type: Types.PROGRAM_STAGE_ERROR, programStageError: error && error.message })
    }
}

/* Upate Request Stage Detail Information */
export const UPDATE_REQUEST_STAGE_DETAILS = (programRequestStages) => (dispatch) => {
    dispatch({ type: Types.PROGRAM_REQUEST_STAGES, programRequestStages })
}
/** Additional Information Stage */
export const GET_ADDITIONAL_INFO_BY_REQUEST_ID = (payload) => async (dispatch) => {
    try {
        const { requestId } = payload;
        if (!requestId) {
            return;
        }
        let additionalInfo = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.ADDITIONAL_INFO}/getRequestAdditionalInfo`, { params: payload });
        dispatch({
            type: Types.GET_ADDITIONAL_INFO_SUCCESS,
            payload: additionalInfo.data ? additionalInfo.data.data : null
        });
    } catch (exception) {
        dispatch({ type: Types.PROGRAM_STAGE_ERROR, programStageError: exception.message })
    }
}
export const SAVE_ADDITIONAL_INFO = (payload) => async (dispatch) => {
    try {
        const { id, requestId } = payload;
        if (!requestId) {
            return;
        }
        let additionalInfo;
        if (id) {
            additionalInfo = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.ADDITIONAL_INFO}/updateRequestAdditionalInfo`, payload);
        } else {
            additionalInfo = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.ADDITIONAL_INFO}/createRequestAdditionalInfo`, payload);
        }
        dispatch({
            type: Types.SAVE_ADDITIONAL_INFO_SUCCESS,
            payload: additionalInfo.data
        });
    } catch (exception) {
        dispatch({ type: Types.PROGRAM_STAGE_ERROR, programStageError: exception.message })
    }
}
export const RESET_ADDITIONAL_INFO = () => (dispatch) => {
    dispatch({
        type: Types.RESET_ADDITIONAL_INFO_DATA,
    });
}


export const SAVE_SERVICE_DATE = (payload) => async (dispatch) => {
    try {
        // const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.REQUEST_DETAILS}`, payload)
        const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.REQUEST_DETAILS}/updateRequestDetails`, payload)
        dispatch({
            type: Types.SAVE_SERVICE_DATE,
            payload: response.data.id
        })

    } catch (error) {
        dispatch({ type: Types.SAVE_SERVICE_DATE_ERROR, payload: error })
    }
}

export const SAVE_PICKUP_DATE = (payload) => async (dispatch) => {
    try {
        // const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.REQUEST_DETAILS}`, payload)
        const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.REQUEST_DETAILS}/updateRequestDetails`, payload)
        dispatch({
            type: Types.SAVE_PICKUP_DATE,
            payload: response.data.id
        })

    } catch (error) {
        dispatch({ type: Types.SAVE_PICKUP_DATE_ERROR, payload: error })
    }
}
// ---------------   REQUEST STATUS INFORMATION ------------------ //

/* List Portal Request Stages */
export const LIST_REQUEST_STATUSES_BASED_OF_STAGES = (payload) => async (dispatch) => {
    try {
        // We need to fetch for every portal request stages and and their statuses
        const { portalId, clientId, requestTypeId } = payload

        if (!portalId || !clientId || !requestTypeId) {
            dispatch({ type: Types.REQUEST_STATUSES_ERROR, requestStatusesError: `Please Provide portal Information` })
        }

        //console.log(`request statuses list ::`, payload )
        const URL = `${LOCAL_URL}${API_REQUESTS.PROGRAM_REQUEST_STAGE_STATUS}/listPortalRequestStatusList`
        // let URL = `${LOCAL_URL}${API_REQUESTS.PROGRAM_REQUEST_STAGE_STATUS}/listPortalRequestStatusList`

        // if(payload.isRequestSubmitted) {
        //        URL = `${LOCAL_URL}${API_REQUESTS.PROGRAM_REQUEST_STATUS_ONLY_COMPLETED}/listPortalRequestStatusList`
        // }

        const responseData = await AuthAxios.axios.get(URL, { params: payload })

        if (responseData && responseData.data) {
            // console.log(`portal request status list:`,responseData)
            dispatch({ type: Types.PORTAL_REQUEST_STATUS_LIST, portalRequestStatusList: responseData.data.data })
        }
    } catch (error) {
        dispatch({ type: Types.REQUEST_STATUSES_ERROR, requestStatusesError: error.message })
    }
}

export const LIST_REQUEST_STATUS_PROGRESS = (requestId) => async (dispatch) => {
    try {
        if (!requestId) {
            // console.log(`request is not found`);
            return;
        }
        const REQUEST_STATUS_PROGRESS_URL = `${LOCAL_URL}${API_REQUESTS.REQUEST_STATUSES_PROGRESS_URL}/fetchRequestStatusProgresses`
        const requestStatusProgress = await AuthAxios.axios.post(REQUEST_STATUS_PROGRESS_URL, { requestId })
        dispatch({ type: Types.REQUEST_STATUSES_PROGRESS, requestStatusProgress: requestStatusProgress.data && requestStatusProgress.data.data })
    } catch (exception) {
        dispatch({ type: Types.REQUEST_STATUSES_ERROR, requestStatusesError: exception.message })
    }
}
export const SELECTED_REQUEST_SEQUENCE = (statusId) => (dispatch) => {
    dispatch({ type: Types.SELECTED_REQUEST_STATUS_SEQUENCE, selectedStatusSequence: statusId })
}
export const SET_REQUEST_REJECTED = (isRequestRejected) => (dispatch) => {
    dispatch({ type: Types.SET_REQUEST_REJECTED, isRequestRejected })
}

export const CLEAR_LIST_REQUEST_STATUS_PROGRESS = () => (dispatch) => {
    dispatch({ type: Types.REQUEST_STATUSES_PROGRESS, requestStatusProgress: [] })
}


export const SET_REQUEST_ERROR = (message) => (dispatch) => {
    dispatch({ type: Types.REQUEST_ERROR, payload: message })
}

export const SET_ADDRESS_COLLECTION_ERROR = (message) => (dispatch) => {
    dispatch({ type: Types.ADD_ADDRESS_COLLECTION_ERROR, payload: message })
}

export const GET_ASSETS_TEMPLATE = (payload) => async (dispatch) => {
    try {
        let url = `${LOCAL_URL}${API_REQUESTS.ASSET_EXCEL_TEMPLATE}`;
        url += '?portalId=' + payload.portalId +
            '&clientName=' + payload.clientName + '&requestTypeId=' + payload.requestTypeId
        // if (url.lastIndexOf('?') > 0) {
        //     url += '&access_token=' + this.session.accessToken;
        // } else {
        //     url += '?access_token=' + this.session.accessToken;
        // }
        //window.open(url, '_blank');
        let date = new Date()
        const fullDate = `${date.getFullYear()}_${date.getMonth() + 1}_${date.getDate()}_${date.getHours()}_${date.getMinutes()}_${date.getSeconds()}`
        const fileName = `${payload.clientName}_${payload.portalId}_${fullDate}.xlsx`
        const response = await AuthAxios.axios.get(url, { responseType: 'blob' })
        const url2 = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url2;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
    }
    catch (e) {
        console.log(e);
        dispatch({ type: Types.ASSETS_DETAIL_SAVE_ERROR, payload: "This portal is empty assets" })
    }
}


/* Fetch Portal Additiona Fields */
export const FETCH_PORTAL_ADDITIONAL_FIELDS = (portalId) => async (dispatch) => {
    try {
        console.log(`Initiate Portal Additional fields`, portalId)
        const ADDITION_FIELD_URL = `${LOCAL_URL}${API_REQUESTS.PORTAL_ADDITIONAL_FIELDS}/fetchPortalAdditionalFields`
        const collectionResponse = await AuthAxios.axios.get(ADDITION_FIELD_URL, { params: { portalId: portalId } })
        if (collectionResponse && collectionResponse.data) {
            dispatch({
                type: Types.PORTAL_ADDITIONAL_FIELD_DATA, portalAdditionalFields: collectionResponse.data.data
            })
        }
    } catch (error) {
        dispatch({ type: Types.PORTAL_ADDITIONAL_FIELD_ERROR, portalAddFieldsError: error && error.message })
    }
}


/* Fetch Request Addition Fields */
export const FETCH_REQUEST_ADDITIONAL_FIELDS = (payload) => async (dispatch) => {
    try {
        const ADDITION_FIELD_URL = `${LOCAL_URL}${API_REQUESTS.REQUEST_ADDITIONAL_FIELDS}/fetchRequestAdditionalFields`
        const requstAddResponse = await AuthAxios.axios.get(ADDITION_FIELD_URL, { params: payload })
        if (requstAddResponse && requstAddResponse.data) {
            dispatch({
                type: Types.REQUEST_ADDITIONAL_FIELD_DATA, requestAddtionalFields: requstAddResponse.data.data
            })
        }
    } catch (error) {
        dispatch({ type: Types.PORTAL_ADDITIONAL_FIELD_ERROR, portalAddFieldsError: error && error.message })
    }
}

/* Update Request Additional Fields */
export const SAVE_REQUEST_ADDITIONAL_FIELDS = (payload) => async (dispatch) => {
    try {
        const ADDITION_FIELD_URL = `${LOCAL_URL}${API_REQUESTS.REQUEST_ADDITIONAL_FIELDS}/saveRequestAdditionalFields`
        const requstAddResponse = await AuthAxios.axios.post(ADDITION_FIELD_URL, payload)
        if (requstAddResponse && requstAddResponse.data) {
            delete payload.requestId
            delete payload.portalId
            delete payload.clientId
            dispatch({
                type: Types.REQUEST_ADDITIONAL_FIELD_DATA, requestAddtionalFields: payload
            })
        }
    } catch (error) {
        dispatch({ type: Types.PORTAL_ADDITIONAL_FIELD_ERROR, portalAddFieldsError: error && error.message })
    }
}

export const USER_CONFIGURATION_BY_ID = (userId) => async (dispatch) => {
    try {
        const response = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.USER_CONFIGURATION_URL}/getuserconfiguration`, { id: userId })
        // const COUNTRY_URL = `${LOCAL_URL}${API_REQUESTS.USER_CONFIGURATION_URL}/getUserConfiguration`
        // const response = await AuthAxios.axios.post(COUNTRY_URL, {id: userId})
        return response?.data?.data;
    } catch (error) {
        dispatch({ type: Types.REQUEST_ERROR, error })
    }
}

export const SUPERVISOR_CONFIGURATION_BY_ID = (userId) => async (dispatch) => {
    try {
        const response = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.USER_CONFIGURATION_URL}/getuserconfiguration`, { id: userId })
        // const COUNTRY_URL = `${LOCAL_URL}${API_REQUESTS.USER_CONFIGURATION_URL}/getUserConfiguration`
        // const response = await AuthAxios.axios.post(COUNTRY_URL, {id: userId})
        return response.data.data;
    } catch (error) {
        dispatch({ type: Types.REQUEST_ERROR, error })
    }
}

export const USER_SAVE_SEARCH = (payload) => async () => {
    try {
        const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.SEARCH_FILTER_URL}/saveFilter`, payload);
        return { success: true, data: response.data.data };
    } catch (error) {
        return {
            success: false, message: error.message
        };
    }
};

export const SEARCH_FILTER_LIST = (payload) => async (dispatch) => {
    try {
        const response = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.SEARCH_FILTER_URL}/getfilterdata`, payload)
        return response.data.data;
    } catch (error) {
        dispatch({ type: Types.REQUEST_ERROR, error })
    }
}

export const GET_SAVE_FILTERS_BY_USER_ID = (userId, pageName) => async (dispatch) => {
    try {
        const response = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.SEARCH_FILTER_URL}/getSavedFilterDataByUserId`, { params: { userId, pageName } })
        // const COUNTRY_URL = `${LOCAL_URL}${API_REQUESTS.USER_CONFIGURATION_URL}/getUserConfiguration`
        // const response = await AuthAxios.axios.post(COUNTRY_URL, {id: userId})
        return response.data.data;
    } catch (error) {
        dispatch({ type: Types.REQUEST_ERROR, error })
    }
}



export const DELETE_SAVE_FILTERS_BY_USER_ID = (userId, id) => async (dispatch) => {
    try {
        const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.SEARCH_FILTER_URL}/deleteFilter`, { userId, id })
        return response.data;
    } catch (error) {
        dispatch({ type: Types.REQUEST_ERROR, error })
    }
}

export const RELEASE_NOTES_INFO = (payload) => async (dispatch) => {
    try {
        const response = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.RELEASE_NOTES_URL}/getreleasenotedata`, { params: payload })
        return response.data.data;
    } catch (error) {
        dispatch({ type: Types.REQUEST_ERROR, error })
    }
}

// export const GET_REFERENCE_FILE = (payload) => async (dispatch) => {
//     try {
//         const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.RELEASE_NOTES_URL}/getReleaseNoteData`,payload)
//         return response.data.data;
//     } catch(error) {
//         dispatch({ type: Types.REQUEST_ERROR , error})
//     }
// }

export const GET_REFERENCE_FILE = (payload) => async (dispatch) => {
    try {

        const { docName } = payload

        const REQ_URL = `${AUTH_SERVICE_URL}/portal/getReleaseNotesFile`

        // const reqResponse = await Axios.axios.post(REQ_URL, payload, { responseType: 'blob' })
        const response = await AuthAxios.axios.post(REQ_URL, payload, { responseType: 'blob' })

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', docName);
        document.body.appendChild(link);
        link.click();
        // return dispatch({
        //     type: Types.GET_RELEASE_NOTES_REFERENCE_FILE_SUCCESS,
        //     fetchFileDetails: reqResponse.data.data
        // })
        // }
    } catch (error) {
        // return dispatch({
        //     type: Types.GET_RELEASE_NOTES_REFERENCE_FILE_ERROR,
        //     error: error && error.message
        // })
    }
}


// export const USER_Hide_All_NewReleaseInfo = (payload) => async (dispatch) => {
//     try {
//         const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.USER_CONFIGURATION_URL}/updateUserConfiguration`, payload)
//         return response.data.data;
//     } catch (error) {
//         if (dispatch) {
//             dispatch({ type: Types.REQUEST_ERROR, error })
//         }
//     }
// }

export const REGIONS = () => async (dispatch) => {
    try {
        const response = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.REGION_URL}/listRegions`)
        const regions = response.data.data
        // dispatch({ type: Types.REGIONS_DETAIL_SUCCESS, payload: regions, });
        return regions;
    } catch (error) {
        dispatch({ type: Types.REQUEST_ERROR, error })
    }
}
export const LIST_ALL_PORTAL_STATUS = (payload) => async (dispatch) => {
    try {
        const { portalId } = payload
        if (!portalId) {
            dispatch({
                type: Types.REQUEST_DOCS_ERROR,
                error: `Please Provide Request Document Information`
            })
        }

        const URL = `${LOCAL_URL}/portalstagestatuses/listAllPortalStageStatus`;
        const response = await AuthAxios.axios.get(URL, { params: payload });
        dispatch({ type: Types.ALL_PORTAL_STATUSES, data: response.data })
    } catch (error) {
        dispatch({
            type: Types.PORTAL_STATUSES_ERROR,
            error: error && error.message
        })
    }
}

export const TRUCKS_LIST = () => async (dispatch) => {
    try {
        const response = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.TRUCK_URL}`)
        return dispatch({
            type: Types.TRUCK_DETAIL_SUCCESS,
            payload: response.data && response.data.data
        })
    } catch (error) {
        dispatch({ type: Types.REQUEST_ERROR, error })
    }
}

export const ADDED_TRUCK_LIST = (payload) => async (dispatch) => {
    try {
        const TRUCK_INFO_URL = `${LOCAL_URL}${API_REQUESTS.TRUCK_URL}/addTruckListInfo`
        const response = await AuthAxios.axios.post(TRUCK_INFO_URL, payload)
        dispatch({
            type: Types.TRUCKS_ADDED_SUCCESS,
            payload: response.data
        })
        return response.data;
    } catch (error) {
        let message = error.message
        if (!message && error.error) {
            message = error.error.message
        }
        dispatch({ type: Types.TRUCK_ERROR, truckError: message })
    }
}

export const setAddNewTruckSizeResponse = (response) => (dispatch) => { dispatch({ type: Types.SET_ADD_NEW_TRUCK_SIZE_RESPONSE, response }) }

export const TRUCKS_UNIT_MEASUREMENT_LIST = (payload) => async (dispatch) => {
    try {
        const response = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.UNIT_MEASUREMENT_TYPE}/getUnitConversionByType`, { params: payload })
        return response.data.data;
    } catch (error) {
        let message = error.message
        if (!message && error.error) {
            message = error.error.message
        }
        dispatch({ type: Types.TRUCK_ERROR, truckError: message })
    }

}

export const SAVE_FEEDBACK = (payload) => async (dispatch) => {
    try {
        const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.USER_FEEDBACK_URL}/submitFeedback`, payload)
        return response.data;
    } catch (error) {
        dispatch({ type: Types.REQUEST_ERROR, error })
    }
}

export const PORTAL_USER_FEEDBACK_QUESTION_LIST = (payload) => async (dispatch) => {
    try {
        const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.USER_FEEDBACK_QUESTIONS}/getPortalQuestion`, payload)
        return response.data.data;
    } catch (error) {
        dispatch({ type: Types.REQUEST_ERROR, error })
    }
}



export const GET_API_DOCUMENT = (payload) => async (dispatch) => {
    try {
        const REQ_URL = `${LOCAL_URL}${API_REQUESTS.REQUEST_DETAILS}/downloadAPIPDF`
        const response = await AuthAxios.axios.post(REQ_URL, payload, { responseType: 'blob' })
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'apidocument.pdf');
        document.body.appendChild(link);
        link.click();
    } catch (error) {
        // return dispatch({
        //     type: Types.GET_RELEASE_NOTES_REFERENCE_FILE_ERROR,
        //     error: error && error.message
        // })
    }
}

export const GET_JWT_TOKEN = (payload) => async (dispatch) => {
    try {
        const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.USER_CONFIGURATION_URL}/generateDevAPIJWTToken`, payload)
        return response.data.data;
    } catch (error) {
        dispatch({ type: Types.REQUEST_ERROR, error })
    }
}

export const GET_PROGRAM_PACKINGS = (payload) => async (dispatch) => {
    try {
        const response = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.PROGRAM_PACKINGS_URL}/listPortalPackings`, { params: payload })
        return response.data.data;
    } catch (error) {
        dispatch({ type: Types.REQUEST_ERROR, error })
    }
}



export const GET_PACKING_SERVICES = (payload) => async (dispatch) => {
    try {
        const { portalId } = payload
        if (!portalId) {
            dispatch({ type: Types.CLIENT_SERVICES_ERROR, payload: `Please provide Service Information properly.` })
            return;
        }

        const response = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.PROGRAM_PACKINGS_URL}/listPortalPackings`, { params: payload })
        dispatch({
            type: Types.PACKING_SERVICES_INFORMATION,
            packingServices: response.data && response.data.data,
        })
    } catch (error) {
        dispatch({ type: Types.CLIENT_SERVICES_ERROR, payload: error })
    }
}
//listProgramPackingFeeGrades


export const GET_PROGRAM_PACKINGS_GRADES = (payload) => async (dispatch) => {
    try {
        const response = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.PROGRAM_PACKINGS_GRADE_URL}/listPortalPackingFeeGrades`, { params: payload })
        dispatch({
            type: Types.PORTAL_PACKING_GRADES,
            packingGrades: response.data && response.data.data,
        })
    } catch (error) {
        dispatch({ type: Types.REQUEST_ERROR, error })
    }

}

export const GET_PROGRAM_PACKINGS_CALCULATION = (payload) => async (dispatch) => {
    try {
        const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.PROGRAM_PACKINGS_URL}/calculateServiceFee`, payload)
        return response.data.data;
    } catch (error) {
        dispatch({ type: Types.REQUEST_ERROR, error })
    }

}

export const DOWNLOAD_COLLECTION_ADDRESS_TEMPLATE = ({ portalId, userId, uom, uomMultiplier, countries }) => async (dispatch) => {
    try {
        const ADDRESS_URL = `${AUTH_SERVICE_URL}/collectionaddress/downloadCollectionTemplate`;
        let date = new Date()
        const fullDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
        const fileName = `CollectionAddress_${fullDate}.xlsx`
        const collectionResponse = await AuthAxios.axios.post(ADDRESS_URL, { fileName, portalId, userId, uom, uomMultiplier, countries }, { responseType: 'blob' })
        const url = window.URL.createObjectURL(new Blob([collectionResponse.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
    } catch (error) {
        dispatch({ type: Types.REQUEST_ERROR, error })
    }
}
export const DOWNLOAD_COLLECTION_ADDRESS_DATA = (payload) => async (dispatch) => {
    try {
        const ADDRESS_URL = `${AUTH_SERVICE_URL}/collectionaddress/downloadCollectionAddressData`;
        let date = new Date()
        const fullDate = `${date.getFullYear()}_${date.getMonth() + 1}_${date.getDate()}_${date.getHours()}_${date.getMinutes()}_${date.getSeconds()}`
        const fileName = `CollectionAddress_${fullDate}.xlsx`
        const collectionResponse = await AuthAxios.axios.post(ADDRESS_URL, payload, { responseType: 'blob' })
        const url = window.URL.createObjectURL(new Blob([collectionResponse.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();


    } catch (error) {

        // dispatch({ type: Types.PORTAL_COLLECTION_ADDRESS_ERROR, addressError: error.message })
    }
}
export const UPLOAD_COLLECTION_ADDRESSES = (fileData, payload) => async (dispatch) => {
    try {
        const ADDRESS_URL = `${AUTH_SERVICE_URL}/collectionaddress/uploadMultipleCollections`;

        const { portalId, clientId, userId } = payload;
        if (!portalId || !clientId) {
            dispatch({ type: Types.PORTAL_COLLECTION_ADDRESS_ERROR, addressError: `Portal Information is not found` })
        }
        let response = await AuthAxios.axios.post(ADDRESS_URL, fileData, { params: payload })
        const collectionSites = response.data.data.map(i => ({
            isActive: i.isActive,
            siteId: i.siteId,
            portalId: i.portalId,
            companyName: i.companyName,
            country: i.country,
            clientId: i.clientId
        }))
        let addedCount = 0;
        let updatedCount = 0;
        if (response && response.data) {
            let recFilter = response.data.data.filter((x) => x.newRecord === true);
            addedCount = recFilter.length;
            recFilter = response.data.data.filter((x) => x.newRecord === false);
            updatedCount = recFilter.length;
            dispatch({ type: Types.BULK_UPLOAD_COLLECTION_SITES, payload: collectionSites })
        }
        dispatch(GET_USER_GROUP_BY_USERID({ portalId, clientId, userId }));
        dispatch(getPortaUserCompanies({ portalId, userId }));
        return { addedCount, updatedCount };
    } catch (error) {
        const addressError = error.error && error.error.message ? error.error && error.error.message : error.error;
        dispatch({ type: Types.PORTAL_COLLECTION_ADDRESS_ERROR, addressError })

    }
}
export const SET_PROGRAM_COLLECTION_ERROR = (message) => (dispatch) => {
    dispatch({ type: Types.PORTAL_COLLECTION_ADDRESS_ERROR, addressError: message })
}

export const SUPERVISOR_USER_UPDATE = (payload) => async () => {
    try {
        await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.SUPERVISOR_USER_ACCESS}/saveSupervisorUserAccess`, payload)
        return "OK";
    } catch (error) {
        return (error && error.message);
    }
}

export const LIST_SUPERVISOR_USER_ACCESS = (payload) => async (dispatch) => {
    try {
        const response = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.SUPERVISOR_USER_ACCESS}/getSupervisorUserAccess`, { params: payload });
        return (response.data && response.data.data)
    } catch (error) {
        return (error && error.message);
    }
}

export const LIST_ALL_SUPERVISOR_USER_ACCESS = (payload) => async (dispatch) => {
    try {
        const response = LIST_ALL_SUPERVISOR_USER_ACCESS2(payload);
        dispatch({
            type: Types.LIST_ALL_SUPERVISOR_USER_ACCESS, allUsersSupervisorAccessData: response.data.data
        })
        return response.data.data
    } catch (error) {
        return (error && error.message);
    }
}

export const LIST_ALL_SUPERVISOR_USER_ACCESS2 = async (payload) => {
    try {
        const response = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.SUPERVISOR_USER_ACCESS}/getAllSupervisorUserAccessList`, { params: payload });
        return response;
    } catch (error) {
        return (error && error.message);
    }
}

export const DELETE_SUPERVISOR_USER_ACCESS = (payload, deletedUserCountryIndex) => async (dispatch) => {
    try {
        const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.SUPERVISOR_USER_ACCESS}/deleteSupervisorUserAccess`, payload);
        return response.data.data;
    } catch (error) {
        return (error && error.message);
    }
}

export const GET_BRAND_DETAILS = (payload) => async () => {
    try {
        const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.PROGRAM_BRANDS}/fetchBrands`, payload)
        return response.data.data;
    } catch (error) {
        return (error && error.message);
    }
}

export const SAVE_ASSET_QUOTATION_INFO = (payload) => async (dispatch) => {
    try {
        const { requestId } = payload;
        if (!requestId) {
            return;
        }
        const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.ASSET_QUOTATION}/createRequestAsset`, payload);
        return response.data.data;
    } catch (error) {
        return (error && error.message);
    }
}

export const SAVE_ASSET_STATUS_QUOTATION_INFO = (payload) => async (dispatch) => {
    try {
        const { id } = payload;
        if (!id) {
            return;
        }
        const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.ASSET_QUOTATION}/updateQuoteStatus`, payload);
        return response.data.data;
    } catch (error) {
        return (error && error.message);
    }
}

export const FETCH_ASSET_QUOTATION_INFO = (payload) => async (dispatch) => {
    try {
        const { requestId } = payload;
        if (!requestId) {
            return;
        }
        const response = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.ASSET_QUOTATION}/fetchAssets/${requestId}`);
        return response.data.data;
    } catch (error) {
        return (error && error.message);
    }
}

//deleteAssetQuoteRecord

export const DELETE_ASSET_STATUS_QUOTATION_INFO = (payload) => async (dispatch) => {
    try {
        const { id } = payload;
        if (!id) {
            return;
        }
        const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.ASSET_QUOTATION}/deleteAssetQuoteRecord`, payload);
        return response.data.data;
    } catch (error) {
        return (error && error.message);
    }
}

export const UPDATE_NEW_REQ_ASSET = (payload) => async (dispatch) => {
    try {
        const { id } = payload;
        if (!id) {
            return dispatch({ type: Types.REQUEST_STATUSES_ERROR, requestStatusesError: `Please Provide Information` })
        }
        const URL = `${LOCAL_URL}${API_REQUESTS.NEW_REQUEST_ASSET}/updateAsset`
        await AuthAxios.axios.post(URL, payload)
    } catch (error) {
        dispatch({ type: Types.REQUEST_STATUSES_ERROR, requestStatusesError: error && error.message })
    }
}

export const UPDATE_SERVICES = (payload) => async (dispatch) => {
    try {
        const response = await AuthAxios.axios.post(`${LOCAL_URL}/requestServices/updateservice`, payload)
        return response.data.data;
    } catch (error) {
        return (error && error.message);
    }
}


export const SAVE_REQUEST_QUOTE_CONTACT_INFO = (payload) => async (dispatch) => {
    try {
        const { requestId } = payload;
        if (!requestId) {
            return;
        }
        const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.QUOTE_REQUEST_CONTACT}/addQuoteContactInfo`, payload);
        return response.data.data;
    } catch (error) {
        throw new Error(error && error.message);
    }
}
export const FETCH_REQUEST_QUOTE_CONTACT_INFO = (payload) => async (dispatch) => {
    try {
        const { requestId } = payload;
        if (!requestId) {
            return;
        }
        const response = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.QUOTE_REQUEST_CONTACT}/fetchQuoteContactInfo`, { params: payload });
        return response.data.data;
    } catch (error) {
        return (error && error.message);
    }
}
export const DELETE_QUOTE_REQUEST_CONTACT_INFO = (payload) => async (dispatch) => {
    try {
        const { id } = payload;
        if (!id) {
            return;
        }
        const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.QUOTE_REQUEST_CONTACT}/deleteQuoteRequestContactRecord`, payload);
        return response.data.data;
    } catch (error) {
        return (error && error.message);
    }
}
export const FETCH_PROCESS_INPUT_SETTING = (payload) => async (dispatch) => {
    try {
        const { portalId } = payload;
        if (!portalId) {
            return;
        }
        const response = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.PROGRAM_REQUEST_STAGE_INPUTS}/fetchPortalRequestTypeFields`, { params: payload });
        return response.data.data;
    } catch (error) {
        return (error && error.message);
    }
}

export const UPLOAD_CLIENT_TEMPLATE = (fileData, payload, fileRawPayload = undefined) => async (dispatch) => {
    try {
        const { portalId, fileName, requestId } = payload
        if (!fileData || !portalId || !fileName || !requestId) {
            return
        }
        const URL = `${AUTH_SERVICE_URL}/portal/uploadClientTemplate`
        const reqResponse = await AuthAxios.axios.post(URL, fileData, { params: payload })
        if (payload.isUploadLargeFile && fileRawPayload !== undefined) {
            const fileRaw = fileRawPayload;
            if (!(fileRaw instanceof Blob)) {
                throw new Error('Invalid fileData.');
            }

            if (fileRaw.size === 0) {
                throw new Error('Invalid fileData. File is empty.');
            }

            if (reqResponse && reqResponse.data) {
                const response = reqResponse.data.data

                if (response.PresignedURL && response.PresignedURL.length > 0) {
                    const options = {
                        method: 'PUT',
                        body: fileRaw,
                        headers: {
                            'Content-Type': response.mimetype,
                        },
                    };
                    try {
                        const fetchResponse = await fetch(response.PresignedURL, options);
                        if (fetchResponse.ok) {
                            return { message: 'Upload Successful!' };
                        } else {
                            throw new Error('File upload failed');
                        }
                    } catch (e) {
                        console.log('File upload failed', e);
                        throw new Error(e);
                    }
                }
            }
        }

        return reqResponse.data && reqResponse.data
    } catch (error) {
        return dispatch({ type: Types.REQUEST_STATUSES_ERROR, error: error && error.message })
    }
}

export const SAVE_REQUEST_CONTACT_INFO = (payload) => async (dispatch) => {
    try {
        const { requestId } = payload;
        if (!requestId) {
            return;
        }
        const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.REQUEST_CONTACT_URL}/addRequestContactInfo`, payload);
        return response.data.data;
    } catch (error) {
        throw new Error(error && error.message);
    }
}

export const GET_REQUEST_CONTACT_INFO = (payload) => async (dispatch) => {
    try {
        const { requestId } = payload;
        if (!requestId) {
            return;
        }
        const response = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.REQUEST_CONTACT_URL}/fetchRequestContactInfo`, { params: payload });
        return response.data.data;
    } catch (error) {
        dispatch({ type: Types.REQUEST_CONTACT_ERROR, payload: error && error.message });
    }
}
export const GET_REQUEST_CONTACT = (payload) => async (dispatch) => {
    try {
        const { name, email } = payload;
        if (!name && !email) {
            return;
        }
        const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.REQUEST_CONTACT_URL}/fetchRequestContact`, { params: payload });
        return response.data.data;
    } catch (error) {
        throw new Error(error && error.message);
    }
}

export const DELETE_REQUEST_CONTACT_INFO = (payload) => async (dispatch) => {
    try {
        const { id } = payload;
        if (!id) {
            return;
        }
        const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.REQUEST_CONTACT_URL}/deleteRequestContactRecord`, payload);
        return response.data.data;
    } catch (error) {
        return (error && error.message);
    }
}

export const GET_PORTAL_CONTACT_BY_SITE_ID = (payload) => async (dispatch) => {
    try {
        const { portalId, siteId } = payload;
        if (!portalId || !siteId) {
            return [];
        }
        const response = await AuthAxios.axios.get(`${AUTH_SERVICE_URL}/client/getPortalContact`, { params: payload });
        return response.data.data;
    } catch (error) {
        throw new Error(error && error.message);
    }
}

export const DELETE_TRANSPORT_SERVICES = (payload) => async (dispatch) => {
    try {
        const { requestId } = payload;
        if (!requestId) {
            return;
        }
        const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.REQUEST_SERVICE}/clearservice`, payload);
        return response.data.data;
    } catch (error) {
        throw new Error(error && error.message);
    }
}

export const DELETE_QUOTATION_SERVICES = (payload) => async (dispatch) => {
    try {
        const { requestId } = payload;
        if (!requestId) {
            return;
        }
        const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.REQUEST_SERVICE}/clearservice`, payload);
        return response.data.data;
    } catch (error) {
        throw new Error(error && error.message);
    }
}

export const DELETE_TRANSPORT_AND_ONSITE_SERVICES = (payload) => async (dispatch) => {
    try {
        const { requestId } = payload;
        if (!requestId) {
            return;
        }
        const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.REQUEST_SERVICE}/cleartransportservice`, payload);
        return response.data.data;
    } catch (error) {
        throw new Error(error && error.message);
    }
}

export const getHolidays = (payload) => async (dispatch) => {
    try {
        const response = await AuthAxios.axios.get(`${LOCAL_URL}/holidays/getHolidays`, { params: payload })
        dispatch({
            type: Types.HOLIDAY_FETCHED,
            payload: response.data.data
        })
    } catch (error) {
        dispatch({ type: Types.HOLIDAY_ERROR, payload: error.message })
    }
}

export const LIST_ALL_CARRIER_CONTACT = (payload) => async (dispatch) => {
    const { carrierId } = payload
    if (!carrierId) {
        return;
    }
    try {
        const response = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.CARRIER_CONTACT}/getCarrierContact`, { params: payload })
        return response.data.data;
    } catch (error) {
        let message = error.message
        if (!message && error && error.error) {
            message = error.error.message
        }
        throw message;
    }
}

export const LIST_COUNTRYID_PROGRAM_CARRIERS = (payload) => async (dispatch) => {
    try {
        const { portalId, partnerId } = payload;
        if (!portalId || !partnerId) {
            return
        }
        const PROGRAM_CARRIER_URL = `${LOCAL_URL}${API_REQUESTS.PORTAL_CARRIER_URL}/listCountryPortalCarriers`
        const response = await AuthAxios.axios.get(PROGRAM_CARRIER_URL, { params: payload })
        return response.data.data;
    } catch (error) {
        let message = error.message
        if (!message && error && error.error) {
            message = error.error.message
        }
        throw message;
    }
}

export const GET_ALL_PALLET = (payload) => async (dispatch) => {
    try {
        const { portalId, clientId } = payload;
        if (!portalId || !clientId) {
            return
        }
        const response = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.PALLET_URL}/getPallets`, { params: payload })
        return response.data.data;
    } catch (error) {
        let message = error.message
        if (!message && error && error.error) {
            message = error.error.message
        }
        throw message;
    }
}

export const GET_PROGRAM_PALLET = (payload) => async (dispatch) => {
    const { portalId, clientId } = payload;
    if (!portalId || !clientId) {
        return
    }
    try {
        const response = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.PALLET_URL}/getProgramPallets`, { params: payload })
        dispatch({
            type: Types.PROGRAM_PALLET_SUCCESS,
            payload: response.data.data
        })
    } catch (error) {
        dispatch({ type: Types.PROGRAM_PALLET_ERROR, payload: error.message })
    }
}

export const GET_REQUEST_PALLET = (payload) => async (dispatch) => {
    const { portalId, requestId } = payload;
    if (!portalId || !requestId) {
        return
    }
    try {
        const response = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.PALLET_URL}/getRequestIdPallets`, { params: payload })
        dispatch({
            type: Types.REQUEST_PALLET_SUCCESS,
            payload: response.data.data
        })
    } catch (error) {
        dispatch({ type: Types.PROGRAM_PALLET_ERROR, payload: error.message })
    }
}

export const ADD_NEW_PALLET = (payload) => async (dispatch) => {
    try {
        const { portalId, clientId } = payload;
        if (!portalId || !clientId) {
            return
        }
        const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.PALLET_URL}/addNewPallet`, payload)
        return response.data;
    } catch (error) {
        dispatch({ type: Types.PROGRAM_PALLET_ERROR, payload: error.error.message })
    }
}

export const ADD_PALLET_ASSETS = (payload) => async (dispatch) => {
    try {
        const { assets, palletId, portalId } = payload;
        if (!assets || !palletId || !portalId) {
            return
        }
        const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.PALLET_URL}/addPalletAsset`, payload)
        return response.data.data;
    } catch (error) {
        let message = error.message
        if (!message && error && error.error) {
            message = error.error.message
        }
        throw message;
    }
}

export const DELETE_PALLET = (payload) => async (dispatch) => {
    try {
        const { portalId, clientId } = payload;
        if (!portalId || !clientId) {
            return
        }
        const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.PALLET_URL}/deletePallet`, payload)
        return response.data.data;
    } catch (error) {
        let message = error.message
        if (!message && error && error.error) {
            message = error.error.message
        }
        throw message;
    }
}

export const MARK_PALLET_COMPLETE = (payload) => async (dispatch) => {
    try {
        const { portalId, clientId } = payload;
        if (!portalId || !clientId) {
            return
        }
        const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.PALLET_URL}/markPalletComplete`, payload)
        return response.data.data;
    } catch (error) {
        let message = error.message
        if (!message && error && error.error) {
            message = error.error.message
        }
        throw message;
    }
}


export const DELETE_PALLET_ASSET = (payload) => async (dispatch) => {
    try {
        const { portalId, clientId } = payload;
        if (!portalId || !clientId) {
            return
        }
        const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.PALLET_URL}/deletePalletAsset`, payload)
        return response.data.data;
    } catch (error) {
        let message = error.message
        if (!message && error && error.error) {
            message = error.error.message
        }
        throw message;
    }
}

export const GET_PALLET_ASSETS = (payload) => async (dispatch) => {
    try {
        const { portalId, clientId } = payload;
        if (!portalId || !clientId) {
            return
        }
        const response = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.PALLET_URL}/getPalletAssets`, { params: payload })
        return response.data.data;
    } catch (error) {
        let message = error.message
        if (!message && error && error.error) {
            message = error.error.message
        }
        throw message;
    }
}

export const GET_PALLET_BY_ID = (payload) => async (dispatch) => {
    try {
        const { palletId } = payload;
        if (!palletId) {
            return
        }
        const response = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.PALLET_URL}/getPalletbyId`, { params: payload })
        return response.data.data[0];
    } catch (error) {
        let message = error.message
        if (!message && error && error.error) {
            message = error.error.message
        }
        throw message;
    }
}

export const GET_PALLET_VALID_REQUEST_TYPE = (payload) => async (dispatch) => {
    try {
        const { portalId, clientId } = payload;
        if (!portalId || !clientId) {
            return
        }
        const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.PALLET_URL}/validRequestTypes`, payload)
        return response.data.data;
    } catch (error) {
        let message = error.message
        if (!message && error && error.error) {
            message = error.error.message
        }
        throw message;
    }
}


export const PALLET_ADD_TO_ASSETEXCEL = (payload) => async (dispatch) => {
    const { requestId, palletId } = payload;
    if (!requestId || !palletId) {
        return
    }
    try {
        dispatch({ type: Types.ASSETS_DETAIL_SAVE });
        const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.SAVE_ASSETS_WITH_PALLET}`, payload);
        return response.data.data;
    } catch (error) {
        dispatch({ type: Types.ASSETS_DETAIL_SAVE_ERROR, payload: error })
    }
}

export const DELETE_PALLET_ASSETEXCEL = (payload) => async (dispatch) => {
    const { requestId, palletId } = payload;
    if (!requestId || !palletId) {
        return
    }
    try {
        dispatch({ type: Types.ASSETS_DETAIL_SAVE });
        const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.DELETE_ASSETS_WITH_PALLET}`, payload);
        return response.data.data;
    } catch (error) {
        dispatch({ type: Types.PROGRAM_PALLET_ERROR, payload: error.message })
    }
}

export const UPDATE_ADD_TO_REQUEST_PALLET = (payload) => async (dispatch) => {
    try {
        dispatch({ type: Types.ASSETS_DETAIL_SAVE });
        const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.UPDATE_REQUEST_IN_PALLET}`, payload);
        return response.data.data;
    } catch (error) {
        dispatch({ type: Types.ASSETS_DETAIL_SAVE_ERROR, payload: error })
    }
}

export const UPDATE_DELETE_TO_REQUEST_PALLET = (payload) => async (dispatch) => {
    try {
        dispatch({ type: Types.ASSETS_DETAIL_SAVE });
        const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.DELETE_REQUEST_IN_PALLET}`, payload);
        return response.data.data;
    } catch (error) {
        dispatch({ type: Types.ASSETS_DETAIL_SAVE_ERROR, payload: error })
    }
}

export const SET_PALLET_ERROR = (message) => (dispatch) => {
    dispatch({ type: Types.PROGRAM_PALLET_ERROR, payload: message })
}

export const GET_REQUESTS_TEMPLATE = (payload) => async (dispatch) => {

    const { portalId, requestTypeId, fileName } = payload;
    if (!portalId || !requestTypeId) {
        return
    }

    try {
        // dispatch({ type: Types.ASSETS_DETAIL_SAVE });
        let URL = `${LOCAL_URL}${API_REQUESTS.PROGRAM_REQUEST_TYPE}/getImportRequestsTemplate`
        const response = await AuthAxios.axios.post(URL, payload, { responseType: 'blob' });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();

        return response.data.data;
    } catch (error) {
        dispatch({ type: Types.ASSETS_DETAIL_SAVE_ERROR, payload: error })
    }
}

export const IMPORT_EOS_REQUEST = (payload) => async (dispatch) => {
    try {
        dispatch({ type: Types.GET_REQUEST });
        const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.REQUEST_DETAILS}/importEOSRequest`, payload)
        console.log(response);
        dispatch({
            type: Types.IMPORT_EOS_REQUEST,
            payload: response.data && response.data.data
        })

    } catch (error) {
        dispatch({ type: Types.GET_REQUEST_ID_ERROR, payload: error && error.message })
    }
}


export const SET_REQUEST_ID_ERROR = (message) => (dispatch) => {
    dispatch({ type: Types.GET_REQUEST_ID_ERROR, payload: message })
}

export const GET_ABIS_DATA = (siteId) => async (dispatch) => {
    try {
      const response = await AuthAxios.axios.get(`${LOCAL_URL}/abisdata`, { params: { siteId } });
      dispatch({ type: Types.ABIS_DATA, data: response?.data?.data });
    } catch (exception) {
      dispatch({ type: Types.STATUSES_ERROR, statusError: exception.message });
    }
}